export { IxIntraportalNav } from './IxIntraportalNav.js';
